<ion-button (click)="close()" fill="clear">
  <ion-icon src="assets/icon/cross.svg" [ngClass]="{ red: isRed }"></ion-icon>
</ion-button>
